import { API } from "./api";

const SID_KEY = "kgf_chat_sid";

export const chatSessionId = () => {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = `s_${(crypto.randomUUID?.() || `${Date.now()}${Math.random()}`).replace(/[^A-Za-z0-9]/g, "").slice(0, 32)}`;
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
};

export const splitOrder = (text = "") => {
  const start = text.indexOf("[[");
  if (start === -1) return { clean: text.trim(), draft: null };
  const end = text.indexOf("[[/ORDER]]", start);
  let draft = null;
  if (end !== -1) {
    try { draft = JSON.parse(text.slice(start + 9, end)); } catch { draft = null; }
  }
  return { clean: text.slice(0, start).trim(), draft };
};

export async function streamChat(sessionId, message, lang, onDelta) {
  const res = await fetch(`${API}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message, lang }),
  });
  if (!res.ok || !res.body) {
    const body = await res.json().catch(() => ({}));
    throw new Error(typeof body?.detail === "string" ? body.detail : "The assistant is unavailable right now.");
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const data = p.replace(/^data: /, "");
      if (data === "[DONE]") return;
      const ev = JSON.parse(data);
      if (ev.error) throw new Error(ev.error);
      if (ev.t) onDelta(ev.t);
    }
  }
}
